import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import stickerMakerApi from '../../api/stickerMakerApi';
import { UserInterface } from "../../store/sticker_maker/usersSlice";
import stickerMakerUrls from "../../configs/sticker_maker/stickerMakerUrls";

const PREFIX = 'sticker_maker';

const processStrategy = (value: any) => {
  return {
    ...value,
    avatar_url: stickerMakerUrls.remoteUrl(value.avatar_url),
    bundle_ico_url: stickerMakerUrls.remoteUrl(value.bundle_ico_url),
    url: stickerMakerUrls.userPath(value.id)
  };
}

export const usersEntity = new schema.Entity(
  'users',
  {},
  {
    processStrategy
  }
);

export const userEntity = new schema.Entity(
  'user',
  {},
  {
    processStrategy
  }
);

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    {
      user: UserInterface
    }
  >(response.data.user, userEntity);
  return normalized.entities;
}

export const fetchUsers = createAsyncThunk(
  `${PREFIX}_users/fetchUsers`,
  async (params: object = {}) => {
    const response    = await stickerMakerApi.get(`/onesky/users`, { params })
    const normalized  = normalize<
      any,
      {
        users: { [key: string]: UserInterface },
      }
    >(response.data.users, [usersEntity]);

    return {
      users: normalized.entities?.users || {},
      ids: normalized.result,
      count: response.data.meta?.total_count
    };
  }
);

export const fetchUser = createAsyncThunk(
  `${PREFIX}_users/fetchUser`,
  async (id: number | string) => {
    const response = await stickerMakerApi.get(`/onesky/users/${id}`);
    return normalizeInstance(response);
  }
);

export const updateUser = createAsyncThunk(
  `${PREFIX}_users/updateUser`,
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await stickerMakerApi.patch(`/onesky/users/${id}`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);

export const destroyUser = createAsyncThunk(
  `${PREFIX}_users/destroyUser`,
  async (id: number) => {
    await stickerMakerApi.delete(`/onesky/users/${id}`);
    return { id: id };
  }
);
